module.exports = __webpack_public_path__ + "img/BRCA4_DC.69f1ffb2.png";